import React from "react";
import siteConfig from "../config/siteConfig";
import PolicyPage from "./PolicyPage";
import "../css/returns.scss";

function Returns() {
  const returnWindow = siteConfig.shipping.returnsWindowDays;
  const sections = [
    {
      id: "window",
      title: "Return window",
      paragraphs: [
        `Eligible items may be returned within ${returnWindow} calendar days of delivery. A return must be requested before the window closes and sent back promptly using the instructions provided by customer care.`,
        "Any mandatory cancellation or consumer rights available in your location continue to apply and may provide different time limits or remedies.",
      ],
    },
    {
      id: "eligibility",
      title: "Return condition",
      paragraphs: [
        "Try garments with care. Returned pieces must be unworn beyond a normal fitting, unwashed, unaltered and free from scent, marks and pet hair, with their original labels attached and protective packaging included.",
      ],
      items: [
        "Final-sale items are returnable only where consumer law requires it.",
        "Items clearly described before purchase as personalised, made to order or altered cannot normally be returned for change of mind.",
        "For hygiene reasons, opened care products or worn intimate accessories cannot normally be accepted.",
      ],
    },
    {
      id: "start",
      title: "How to request a return",
      paragraphs: [
        `Email ${siteConfig.contact.email} with your order number, the items you wish to return and the reason for your request. We will reply with the applicable return address and packing instructions.`,
        "Do not send items to the studio address without authorisation. Use a tracked service and retain the receipt until the return is complete, as responsibility for an independently posted parcel remains with the sender until it reaches the return location.",
      ],
    },
    {
      id: "return-costs",
      title: "Return postage and international returns",
      paragraphs: [
        "Change-of-mind return postage is paid by the customer unless the order or applicable law states otherwise. The customer is also responsible for accurate customs documentation. Mark an international parcel as returned merchandise and keep evidence of the original export; we are not responsible for avoidable duties caused by incorrect return paperwork.",
        "We cover reasonable return costs when we confirm that an item is faulty, damaged in transit, materially misdescribed or sent in error. Contact us before posting so that the appropriate service can be arranged.",
      ],
    },
    {
      id: "refunds",
      title: "Inspection and refunds",
      paragraphs: [
        "We will inspect an authorised return after it arrives. An approved refund is issued to the original payment method, normally within 5–10 working days of inspection. Your bank or card provider may take additional time to display it.",
        "Original standard delivery charges are refunded only where required by law. Express upgrades and return postage are normally excluded. If an item is returned outside the policy or in a diminished condition, the refund may be declined or reasonably reduced where permitted.",
      ],
    },
    {
      id: "exchanges",
      title: "Exchanges",
      paragraphs: [
        "Because quantities are intentionally limited, direct exchanges are not reserved. The clearest route is to return the original piece and place a separate order for the preferred size or colour. Each transaction is assessed independently.",
      ],
    },
    {
      id: "faults",
      title: "Incorrect, damaged or faulty items",
      paragraphs: [
        "Contact customer care promptly if the wrong item arrives or a piece appears damaged or faulty. Include the order number and photographs of the garment, labels and parcel. Do not arrange a return until instructions are provided; reasonable return costs for a confirmed issue will be covered. This policy does not limit statutory remedies.",
      ],
    },
    {
      id: "fair-use",
      title: "Fair use",
      paragraphs: [
        "Returns are reviewed to protect customers and prevent abuse. We may refuse a return involving substituted goods, deliberate damage, repeated unreasonable use or fraudulent documentation. A decision under this section will be explained and will not affect a genuine statutory claim.",
      ],
    },
  ];

  return (
    <div className="returns">
      <PolicyPage
        title="Returns and refunds"
        intro={`A considered returns process for pieces ordered from ${siteConfig.brandName}.`}
        sections={sections}
        relatedLinks={[
          { label: "Shipping", to: "/shipping" },
          { label: "Cancellation policy", to: "/cancellations" },
          { label: "Warranty and faulty goods", to: "/warranty" },
          { label: "Contact customer care", to: "/contact" },
          { label: "All policies", to: "/policies" },
        ]}
      />
    </div>
  );
}

export default Returns;
